// Pure appointment identity — no Firebase imports, so unit tests can import it without dragging in the
// live Firestore/gRPC stack (which crashes jsdom on setImmediate). Consumed by appointmentService's
// import upsert. BEHAVIOR-PIN: project-slik-production-safety-net-2026-09-11.

/**
 * Stable business key for an appointment: the same client + barber + date + time is the SAME visit.
 * Used by the import upsert so re-dropping a file can't create duplicates.
 */
export function appointmentDedupeKey(a: {
  clientId?: string; clientName?: string; clientPhone?: string;
  barberId?: string; date?: string; time?: string;
}): string {
  const who = String(a.clientPhone || a.clientId || a.clientName || '').trim().toLowerCase().replace(/\s+/g, ' ');
  return `${who}|${a.barberId || ''}|${a.date || ''}|${a.time || ''}`;
}
